@if (quarters.length) {
<div class="quarter-selector">
    <select [ngModel]="selected" (ngModelChange)="onChange($event)">
        <option value="">All Time</option>
        @for (q of quarters; track q) {
        <option [value]="q.value">{{ q.label }}{{ q.current ? ' (current)' : '' }}</option>
        }
    </select>
</div>
}
